<template>
  <div class="property-deduction-use-ratio-config">
    <el-card>
      <div slot="header">抵扣金使用比例配置</div>

      <div class="query-bar">
        <el-form :inline="true" :model="query" size="small">
          <el-form-item label="配置范围">
            <el-select v-model="query.scopeType" placeholder="全部" clearable style="width: 160px;">
              <el-option label="平台" value="PLATFORM" />
              <el-option label="小区" value="COMMUNITY" />
              <el-option label="店铺" value="SHOP" />
            </el-select>
          </el-form-item>
          <el-form-item label="范围对象ID">
            <el-input v-model="query.scopeId" placeholder="选择小区/店铺后填写对应ID" clearable style="width: 200px;" />
          </el-form-item>
          <el-form-item label="业务类型">
            <el-select v-model="query.businessType" placeholder="全部" clearable style="width: 160px;">
              <el-option label="普通商品" value="buyGoods" />
              <el-option label="秒杀商品" value="buyKillGoods" />
              <el-option label="团购商品" value="buyGroupGoods" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryConfigs(1)">查询</el-button>
            <el-button @click="resetQuery">重置</el-button>
            <el-button type="success" @click="openAddDialog">新增配置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table :data="configs" border stripe style="width: 100%">
        <el-table-column prop="scopeType" label="配置范围" align="center">
          <template #default="{ row }">{{ formatScopeType(row.scopeType) }}</template>
        </el-table-column>
        <el-table-column prop="scopeId" label="范围对象ID" align="center">
          <template #default="{ row }">{{ row.scopeId || '-' }}</template>
        </el-table-column>
        <el-table-column prop="businessType" label="业务类型" align="center">
          <template #default="{ row }">{{ formatBusinessType(row.businessType) }}</template>
        </el-table-column>
        <el-table-column prop="useRatio" label="使用比例" align="center">
          <template #default="{ row }">{{ formatRatio(row.useRatio) }}</template>
        </el-table-column>
        <el-table-column prop="statusCd" label="状态" align="center" width="100">
          <template #default="{ row }">{{ formatStatus(row.statusCd) }}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" />
        <el-table-column label="操作" align="center" width="150">
          <template #default="{ row }">
            <el-button type="text" size="small" @click="editConfig(row)">编辑</el-button>
            <el-button type="text" size="small" style="color: #f56c6c;" @click="deleteConfig(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        background
        layout="total, prev, pager, next"
        :current-page="query.page"
        :page-size="query.row"
        :total="total"
        @current-change="queryConfigs"
      />
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="small">
        <el-form-item label="配置范围" prop="scopeType">
          <el-tooltip effect="dark" placement="top">
            <div slot="content">
              平台：全局默认配置，对所有小区/店铺生效<br>
              小区：仅对指定小区生效，需填写小区ID<br>
              店铺：仅对指定店铺生效，需填写店铺ID
            </div>
            <el-select v-model="form.scopeType" placeholder="请选择配置范围" style="width: 100%;" @change="onScopeTypeChange">
              <el-option label="平台" value="PLATFORM" />
              <el-option label="小区" value="COMMUNITY" />
              <el-option label="店铺" value="SHOP" />
            </el-select>
          </el-tooltip>
        </el-form-item>
        <el-form-item v-if="form.scopeType !== 'PLATFORM'" :label="scopeIdLabel" prop="scopeId">
          <el-input v-model="form.scopeId" :placeholder="'请输入' + scopeIdLabel" clearable />
        </el-form-item>
        <el-form-item v-else label="范围对象ID">
          <el-input value="平台级默认配置，无需填写" disabled />
        </el-form-item>
        <el-form-item label="业务类型" prop="businessType">
          <el-select v-model="form.businessType" placeholder="请选择业务类型" style="width: 100%;">
            <el-option label="普通商品" value="buyGoods" />
            <el-option label="秒杀商品" value="buyKillGoods" />
            <el-option label="团购商品" value="buyGroupGoods" />
          </el-select>
        </el-form-item>
        <el-form-item label="使用比例" prop="useRatio">
          <el-input-number v-model="form.useRatio" :precision="4" :min="0" :max="1" :step="0.01" controls-position="right" />
          <span style="margin-left: 8px;">{{ formatRatio(form.useRatio) }}</span>
        </el-form-item>
        <el-form-item v-if="isEdit" label="状态" prop="statusCd">
          <el-radio-group v-model="form.statusCd">
            <el-radio label="0">有效</el-radio>
            <el-radio label="1">无效</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="saveConfig">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

const CMD_URL = '/propertyDeduction.useRatioConfig'

export default {
  name: 'UseRatioConfig',
  data() {
    return {
      query: {
        scopeType: '',
        scopeId: '',
        businessType: '',
        page: 1,
        row: 10
      },
      configs: [],
      total: 0,
      dialogVisible: false,
      form: {
        ratioId: '',
        scopeType: '',
        scopeId: '',
        businessType: '',
        useRatio: 1,
        statusCd: '0'
      },
      rules: {
        scopeType: [{ required: true, message: '请选择配置范围', trigger: 'change' }],
        scopeId: [{ required: true, message: '请填写范围对象ID', trigger: 'blur' }],
        businessType: [{ required: true, message: '请选择业务类型', trigger: 'change' }],
        useRatio: [{ required: true, message: '请输入使用比例', trigger: 'blur' }]
      }
    }
  },
  computed: {
    isEdit() {
      return !!this.form.ratioId
    },
    dialogTitle() {
      return this.isEdit ? '编辑使用比例配置' : '新增使用比例配置'
    },
    scopeIdLabel() {
      if (this.form.scopeType === 'COMMUNITY') return '小区ID'
      if (this.form.scopeType === 'SHOP') return '店铺ID'
      return '范围对象ID'
    }
  },
  mounted() {
    this.queryConfigs(1)
  },
  methods: {
    queryConfigs(page) {
      if (page) {
        this.query.page = page
      }
      request({
        url: CMD_URL,
        method: 'post',
        data: {
          action: 'query',
          scopeType: this.query.scopeType,
          scopeId: this.query.scopeId,
          businessType: this.query.businessType,
          page: this.query.page,
          row: this.query.row
        }
      }).then(response => {
        const result = response.data || {}
        const res = result.data || {}
        this.configs = res.configs || []
        this.total = res.total || this.configs.length
      }).catch(() => {
        this.$message.error('查询配置失败')
      })
    },
    resetQuery() {
      this.query.scopeType = ''
      this.query.scopeId = ''
      this.query.businessType = ''
      this.query.page = 1
      this.queryConfigs(1)
    },
    openAddDialog() {
      this.form = {
        ratioId: '',
        scopeType: '',
        scopeId: '',
        businessType: '',
        useRatio: 1,
        statusCd: '0'
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    editConfig(row) {
      this.form = {
        ratioId: row.ratioId,
        scopeType: row.scopeType || '',
        scopeId: row.scopeId || '',
        businessType: row.businessType || '',
        useRatio: row.useRatio == null ? 1 : Number(row.useRatio),
        statusCd: row.statusCd || '0'
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    saveConfig() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const action = this.isEdit ? 'update' : 'save'
        const payload = {
          action,
          ratioId: this.form.ratioId,
          scopeType: this.form.scopeType,
          scopeId: this.form.scopeType === 'PLATFORM' ? '' : this.form.scopeId,
          businessType: this.form.businessType,
          useRatio: this.form.useRatio
        }
        if (this.isEdit) {
          payload.statusCd = this.form.statusCd
        }
        request({
          url: CMD_URL,
          method: 'post',
          data: payload
        }).then(() => {
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.queryConfigs(1)
        }).catch(() => {
          this.$message.error('保存失败')
        })
      })
    },
    deleteConfig(row) {
      this.$confirm('确认删除该使用比例配置？', '提示', { type: 'warning' }).then(() => {
        request({
          url: CMD_URL,
          method: 'post',
          data: {
            action: 'delete',
            ratioId: row.ratioId
          }
        }).then(() => {
          this.$message.success('删除成功')
          this.queryConfigs(1)
        }).catch(() => {
          this.$message.error('删除失败')
        })
      }).catch(() => {})
    },
    onScopeTypeChange(scopeType) {
      if (scopeType === 'PLATFORM') {
        this.form.scopeId = ''
      }
    },
    formatScopeType(scopeType) {
      if (scopeType === 'PLATFORM') return '平台'
      if (scopeType === 'COMMUNITY') return '小区'
      if (scopeType === 'SHOP') return '店铺'
      return scopeType || '-'
    },
    formatBusinessType(businessType) {
      if (businessType === 'buyGoods') return '普通商品'
      if (businessType === 'buyKillGoods') return '秒杀商品'
      if (businessType === 'buyGroupGoods') return '团购商品'
      return businessType || '-'
    },
    formatRatio(value) {
      if (value === undefined || value === null || value === '') return '-'
      const ratio = parseFloat(value) || 0
      return ratio + '（' + (ratio * 100).toFixed(2) + '%）'
    },
    formatStatus(statusCd) {
      if (statusCd === '0') return '有效'
      if (statusCd === '1') return '无效'
      return statusCd || '-'
    }
  }
}
</script>

<style lang="scss" scoped>
.property-deduction-use-ratio-config {
  .query-bar {
    margin-bottom: 16px;
  }
  .pagination {
    margin-top: 16px;
    text-align: right;
  }
}
</style>
